const R = require('ramda')

const baseURL = require('./base-url')

const firstLetter = R.nthChar(0)
const firstPropLetter = R.compose(firstLetter, R.prop)
const webUtils = {
  firstPropLetter,

  acronym (item) {
    if (item.firstName && item.lastName) {
      return firstPropLetter('firstName', item) + firstPropLetter('lastName', item)
    } if (item.firstName) {
      return firstPropLetter('firstName', item)
    } if (item.name) {
      return firstPropLetter('name', item)
    }
    return firstPropLetter('email', item)
  },

  calcPct (nominator, denominator) {
    if (nominator != null && denominator != null) {
      return (100 * (nominator / denominator)).toFixed(1)
    }
    return undefined
  },

  getFileURL (fileId) {
    return R.join('/', [ baseURL, 'files', fileId ])
  },

}

module.exports = webUtils
